import React from "react";
import {Grid} from "@mui/material";
import LoginForm from "components/Login/LoginForm";
import LoginOnboarding from "components/Login/LoginOnboarding";


const Login = () => {

  return (
    <Grid container sx={{ height: "100vh", padding: "16px" }}>
      <LoginForm/>
      <LoginOnboarding/>
    </Grid>
  );
};

export default Login;
